import { render, staticRenderFns } from "./AlertSeverityTag.vue?vue&type=template&id=40229296"
import script from "./AlertSeverityTag.vue?vue&type=script&lang=js"
export * from "./AlertSeverityTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports